










































import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator';
import CurrencyTextInput from '@/pro/components/common/input/CurrencyTextInfput.vue';
import TextInput from '@/pro/components/common/input/TextInput.vue';
import {formatCurrency} from '@/pro/utils/numberFormat';
import {CommissionOption} from '@/pro/views/contents/product/basic/ProductAdd/salesInfo/details/CommissionInfo.vue';
import {InputNumber} from '@/pro/types';
@Component({
  components: { Currency: CurrencyTextInput, TextInput },
  computed: {
    isDirectInsertPurchasePrice(): boolean {
      return this.commissionInfo.type === 'PURCHASE_PRICE';
    },
    formattedImmediateDiscountPrice(): string {
      return formatCurrency(this.immediateDiscountPrice);
    },
  },
})
export default class ImmediateDiscountPrice extends Vue {
  // 사입-매입가
  @Prop({ required: true })
  private readonly isPurchaseType: boolean;

  @Prop()
  private readonly useOption!: boolean;

  @Prop()
  private readonly commissionInfo!: CommissionOption;

  @Prop({ default: 0 })
  private readonly immediateDiscountPrice!: number;

  @PropSync('supplyPrice', { default: 0 })
  private supplyPriceSync: number;

  @Prop({ required: true })
  private readonly defaultSupplyPrice: number;

  private formattedSalePrice: InputNumber = '';
  @Watch('isPurchaseType')
  private reset() {
    // 사입일 경우 '' 초기값 세팅 && 위탁인 경우 공급가 세팅
    this.formattedSalePrice = this.isPurchaseType ? '' : this.supplyPriceSync;
  }

  @Watch('formattedSalePrice')
  private setSupplyPrice() {
    if (this.isPurchaseType) {
      this.supplyPriceSync = this.formattedSalePrice === '' ? 0 : Number(this.formattedSalePrice);
    }
  }

  private initSupplyPrice = false;
  @Watch('defaultSupplyPrice')
  private setDefaultSupplyPrice() {
    this.initSupplyPrice = true;
    this.supplyPriceSync = this.defaultSupplyPrice;
    this.formattedSalePrice = this.defaultSupplyPrice;
  }

  @Watch('supplyPrice')
  private setFormattedSalePrice() {
    if (this.initSupplyPrice && !this.$route.path.includes('add')) {
      this.initSupplyPrice = false;
      return;
    }
    this.formattedSalePrice = this.supplyPriceSync;
  }
}
